import { ConceptCode } from '@tiendanube/common';

export const CONCEPTS_TO_SHOW: ConceptCode[] = [
  'plan-cost',
  'app-cost',
  'app-nuvemchat-cost',
];
